import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import styled from 'styled-components';
import { Text, Title } from '@yoweb/ui/components/typography';
import { Badge } from '@yoweb/ui/components/indicators';
import { useTranslation } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import { ButtonIcon } from '@yoweb/ui/components/buttons';
import { AddIcon } from '@yoweb/ui/components/Icon/AddIcon';
import { CardButtonWrapper } from '@poplar/components/TaskTemplate/CardButtonWrapper';
import { pxToRem, media } from '@yoweb/ui/styles/utils';
import { LineClamp } from '@yoweb/ui/components/LineClamp';
import { trackEvent } from '@yoweb/utils/analytics/mixpanel';
import { getColor, getSpace } from '@yoweb/ui/styles/utils/theme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MAX_LINE_CLAMP = 3;
export var FeatureCard = function FeatureCard(_ref) {
  var card = _ref.card,
      onClick = _ref.onClick,
      cursor = _ref.cursor;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(StyledCardButtonWrapper, {
    onClick: function (_onClick) {
      function onClick() {
        return _onClick.apply(this, arguments);
      }

      onClick.toString = function () {
        return _onClick.toString();
      };

      return onClick;
    }(function () {
      onClick();
      trackEvent({
        featuredTodoView: {
          title: card.title
        }
      });
    }),
    cursor: cursor,
    children: /*#__PURE__*/_jsxs(CardLayout, {
      "data-testid": "feature-card",
      children: [/*#__PURE__*/_jsx(Box, {
        display: "flex",
        children: /*#__PURE__*/_jsxs(BadgeContainer, {
          children: [card.isTaskTemplateForDogfoodTesting && /*#__PURE__*/_jsx(Badge, {
            type: "fill",
            backgroundColor: "warningLight",
            borderRadius: "tiny",
            children: t('todo-intake.testing')
          }), card.templateBadgesList.map(function (badge) {
            return /*#__PURE__*/_jsx(Badge, {
              type: "fill",
              backgroundColor: "skyLight",
              borderRadius: "tiny",
              children: badge
            }, badge);
          })]
        })
      }), /*#__PURE__*/_jsxs(Box, {
        gap: "small3",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Title, {
          size: "sm",
          title: card.title,
          children: /*#__PURE__*/_jsx(LineClamp, {
            lines: MAX_LINE_CLAMP,
            children: card.title
          })
        }), /*#__PURE__*/_jsxs(Box, {
          display: "flex",
          gap: "small3",
          justifyContent: "space-between",
          flex: "1",
          children: [/*#__PURE__*/_jsx(Box, {
            children: /*#__PURE__*/_jsx(Text, {
              title: card.description,
              children: /*#__PURE__*/_jsx(LineClamp, {
                lines: MAX_LINE_CLAMP,
                children: card.description
              })
            })
          }), /*#__PURE__*/_jsx(Box, {
            display: "flex",
            alignItems: "flex-end",
            children: /*#__PURE__*/_jsx(ButtonIcon, {
              mode: "dark",
              size: "md",
              isFloating: false,
              icon: /*#__PURE__*/_jsx(AddIcon, {
                size: 18
              }),
              bgColor: "gingko"
            })
          })]
        })]
      })]
    })
  });
};
var CardLayout = styled.div.withConfig({
  componentId: "sc-1pltfbq-0"
})(["display:grid;grid-template-rows:min-content 1fr;gap:", ";padding:", ";border-radius:0.41rem;width:", ";height:100%;background-color:", ";", " ", ""], getSpace('small4'), getSpace('normal1'), pxToRem(300), getColor('base000'), media.sm(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n"])), pxToRem(480)), media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), getSpace('normal2')));
var StyledCardButtonWrapper = styled(CardButtonWrapper).withConfig({
  componentId: "sc-1pltfbq-1"
})(["&&{cursor:", ";margin:", ";}"], function (_ref2) {
  var cursor = _ref2.cursor;
  return cursor !== null && cursor !== void 0 ? cursor : 'pointer';
}, pxToRem(1));
var BadgeContainer = styled.div.withConfig({
  componentId: "sc-1pltfbq-2"
})(["display:flex;min-height:", ";left:", ";top:", ";div:not(:first-child){margin-left:6px;}"], pxToRem(24), pxToRem(16), pxToRem(16));